import { Row, Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function NavigationBack({ inline = false }) {
  const navigate = useNavigate();

  const core = (
    <Button
      variant="light"
      onClick={() => {
        navigate(-1);
      }}
      className={`d-print-none`}
    >
      <i
        className={`bi bi-chevron-left me-1`}
        style={{
          fontSize: "12px",
        }}
      ></i>
      Back
    </Button>
  );

  if (inline) {
    return core;
  }

  return (
    <Row style={{ padding: "5px 0px", marginLeft: "0px" }}>
      <div>{core}</div>
    </Row>
  );
}
